export default __webpack_public_path__ + "static/media/salad_beans.5f7d75b1.jpg";